import { render, staticRenderFns } from "./aboutUsItem.vue?vue&type=template&id=5cb37970&scoped=true&"
import script from "./aboutUsItem.vue?vue&type=script&lang=js&"
export * from "./aboutUsItem.vue?vue&type=script&lang=js&"
import style0 from "./aboutUsItem.vue?vue&type=style&index=0&id=5cb37970&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb37970",
  null
  
)

export default component.exports